import React, { useMemo, useState } from "react";
import { FaEye, FaPaperclip, FaChevronLeft, FaChevronRight, FaSearch, FaTimes } from "react-icons/fa";

const prettyDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value).slice(0, 10);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};
const moneyQty = (value) => value === null || value === undefined || value === "" ? "—" : Number(value).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const statusClass = (status) => {
  const s = String(status || "").toUpperCase();
  if (s.includes("FINANCE")) return "finance";
  if (s.includes("APPROVAL")) return "approval";
  if (s.includes("REQUIREMENT")) return "requirement";
  if (s.includes("ACCOUNT")) return "accounts";
  if (s.includes("PURCHASE") || s.includes("ORDER")) return "purchase";
  if (s.includes("INSPECTION")) return "inspection";
  if (s.includes("RECEIPT") || s.includes("RECEIVED")) return "receipt";
  if (s.includes("COMPLETED")) return "completed";
  if (s.includes("REJECT")) return "rejected";
  return "default";
};

const sortNewestFirst = (items) => [...items].sort((a, b) => {
  const dateA = a?.created_at ? new Date(a.created_at).getTime() : NaN;
  const dateB = b?.created_at ? new Date(b.created_at).getTime() : NaN;
  const validA = Number.isFinite(dateA);
  const validB = Number.isFinite(dateB);
  if (validA && validB && dateA !== dateB) return dateB - dateA;
  if (validA !== validB) return validA ? -1 : 1;
  const idA = Number(a?.case_id);
  const idB = Number(b?.case_id);
  if (Number.isFinite(idA) && Number.isFinite(idB) && idA !== idB) return idB - idA;
  return 0;
});

const css = `
.sd-table-wrap{background:white;border:1px solid #dce8f6;border-radius:11px;overflow:hidden;box-shadow:0 3px 12px #17365d08}
.sd-table-searchbar{display:flex;align-items:center;gap:10px;padding:14px 16px;background:#fff;border-bottom:1px solid #e8eef5}
.sd-table-searchbox{display:flex;align-items:center;gap:10px;width:min(560px,100%);height:42px;padding:0 12px;border:1px solid #d4dfed;border-radius:8px;background:#fff;color:#718096;transition:border-color .15s,box-shadow .15s}
.sd-table-searchbox:focus-within{border-color:#0875f9;box-shadow:0 0 0 3px #0875f91a}
.sd-table-searchbox input{width:100%;min-width:0;border:0;outline:0;background:transparent;color:#26364d;font-size:14px}
.sd-table-searchbox input::placeholder{color:#8997a9}
.sd-search-clear{border:0;background:transparent;color:#718096;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:5px}
.sd-search-count{font-size:12px;color:#74849a;margin-left:auto;white-space:nowrap}
.sd-table-scroll{width:100%;overflow:auto}
.sd-table{width:100%;border-collapse:separate;border-spacing:0;min-width:1150px;font-size:13px}
.sd-table thead th{background:linear-gradient(110deg,#172b41,#25384c);color:#fff;font-weight:700;padding:15px 10px;white-space:nowrap;border-right:1px solid #ffffff1a}
.sd-table tbody td{padding:10px;border-right:1px solid #e5edf5;border-bottom:1px solid #e5edf5;color:#26364d;vertical-align:middle}
.sd-table tbody tr:hover{background:#f5f9ff}.sd-table tbody tr:last-child td{border-bottom:0}.sd-table .center{text-align:center}
.sd-status{display:inline-flex;align-items:center;justify-content:center;min-width:95px;padding:7px 10px;border-radius:6px;font-size:10px;font-weight:800;white-space:nowrap}
.sd-status.finance{background:#fff3d9;color:#a66b00}.sd-status.approval{background:#f1ddff;color:#6b21a8}.sd-status.requirement{background:#ddecff;color:#1c58a5}.sd-status.accounts{background:#dff9df;color:#16803b}.sd-status.purchase{background:#ffe2e2;color:#c62828}.sd-status.inspection{background:#eee4ff;color:#5c2da8}.sd-status.receipt{background:#d3fbf1;color:#087d68}.sd-status.completed{background:#dcfce7;color:#166534}.sd-status.rejected{background:#fee2e2;color:#b91c1c}.sd-status.default{background:#e8eef5;color:#455a70}
.sd-account{display:inline-block;max-width:155px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:7px 8px;border-radius:6px;background:#e2f1ff;color:#1a5d9e;font-size:10px;font-weight:800}.sd-account.gsd{background:#def9e7;color:#147443}
.sd-actions{display:flex;gap:6px;align-items:center;justify-content:center}.sd-view-btn,.sd-attachment-btn{border:0;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;gap:7px;height:36px;font-weight:700}.sd-view-btn{background:#e1efff;color:#0870e9;padding:0 13px}.sd-view-btn:hover{background:#cfe4ff}.sd-attachment-btn{width:36px;background:#fff;border:1px solid #b7d7ff;color:#0870e9}.sd-attachment-btn:hover{background:#eef6ff}
.sd-table-footer{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:15px 20px;background:#fff;border-top:1px solid #e8eef5}.sd-total{color:#74849a}.sd-total strong{color:#0875f9;font-size:16px}.sd-page-controls{display:flex;align-items:center;gap:7px;flex-wrap:wrap}.sd-page-controls select{height:40px;border:1px solid #d8e1ed;border-radius:7px;padding:0 10px;background:#fff}.sd-page-btn{height:40px;min-width:40px;border:1px solid #d8e1ed;border-radius:7px;background:white;color:#42546c}.sd-page-btn.active{background:#0875f9;color:white;border-color:#0875f9;font-weight:800}.sd-page-btn:disabled{opacity:.4;cursor:not-allowed}.sd-empty{padding:35px!important;text-align:center!important;color:#7a8ca3!important}
@media(max-width:700px){.sd-table-footer{align-items:flex-start;flex-direction:column}.sd-page-controls{width:100%}.sd-table-searchbar{align-items:flex-start;flex-direction:column}.sd-search-count{margin-left:0}}
`;

export default function ProcurementTable({
  rows = [], totalRows = 0, page = 1, totalPages = 1, pageSize = 7,
  onPageChange = () => {}, onPageSizeChange = () => {},
  onView = () => {}, onHistory = () => {},
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const accountLabel = (value) => String(value || "—").replaceAll("_", " ");
  const sortedRows = useMemo(() => sortNewestFirst(rows), [rows]);
  const filteredRows = useMemo(() => {
    const q = searchTerm.trim().toLocaleLowerCase();
    if (!q) return sortedRows;
    return sortedRows.filter((row) => {
      const searchableValues = [
        row.case_id, row.file_number, row.e_office_number, row.demand_number,
        row.item_name, row.item_id, row.quantity, row.unit, row.account_type,
        row.current_status, row.pending_since, row.recent_remark, row.remarks,
        row.created_by, row.created_at, row.demand_date, row.intimation_date,
      ];
      return searchableValues.some((value) => value !== null && value !== undefined && String(value).toLocaleLowerCase().includes(q));
    });
  }, [sortedRows, searchTerm]);

  // Search is instant. Pagination controls remain connected to the parent component.
  const effectiveTotal = searchTerm.trim() ? filteredRows.length : totalRows;
  const start = effectiveTotal === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, effectiveTotal);

  return (
    <>
      <style>{css}</style>
      <section className="sd-table-wrap">
        <div className="sd-table-searchbar">
          <label className="sd-table-searchbox">
            <FaSearch aria-hidden="true" />
            <input
              type="search"
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
              placeholder="Search file, e-office, demand, item, status, remarks..."
              aria-label="Search procurement table"
            />
            {searchTerm && <button type="button" className="sd-search-clear" onClick={() => setSearchTerm("")} aria-label="Clear search"><FaTimes /></button>}
          </label>
          <span className="sd-search-count">{searchTerm.trim() ? `${filteredRows.length} matching row${filteredRows.length === 1 ? "" : "s"}` : `${totalRows} entries`}</span>
        </div>
        <div className="sd-table-scroll">
          <table className="sd-table">
            <thead><tr>
              <th className="center">S.No.</th><th>File Number ↕</th><th>E-Office No.</th>
              <th>Demand No.</th><th>Item Name ↕</th><th>Quantity</th><th>Unit</th>
              <th>Account Type ↕</th><th>Current Status ↕</th><th>Pending Since ↕</th>
              <th>Remarks ↓</th><th className="center">Action</th>
            </tr></thead>
            <tbody>
              {filteredRows.length === 0 ? <tr><td className="sd-empty" colSpan={12}>{searchTerm.trim() ? "No entries match your search." : "No procurement entries match your filters."}</td></tr> :
                filteredRows.map((row, index) => {
                  const account = accountLabel(row.account_type);
                  const status = String(row.current_status || "—").toUpperCase();
                  return <tr key={row.case_id ?? `${row.file_number}-${index}`}>
                    <td className="center">{start + index}</td>
                    <td>{row.file_number || "—"}</td>
                    <td>{row.e_office_number || "—"}</td>
                    <td>{row.demand_number || "—"}</td>
                    <td>{row.item_name || "—"}</td>
                    <td>{moneyQty(row.quantity)}</td>
                    <td>{row.unit || "—"}</td>
                    <td><span className={`sd-account ${account.includes("GSD") ? "gsd" : ""}`} title={account}>{account}</span></td>
                    <td><span className={`sd-status ${statusClass(status)}`}>{status.replaceAll("_", " ")}</span></td>
                    <td>{prettyDate(row.pending_since)}</td>
                    <td title={row.recent_remark || row.remarks || "—"}>{row.recent_remark || row.remarks || "—"}</td>
                    <td><div className="sd-actions">
                      <button type="button" className="sd-view-btn" title="View / Edit demand" onClick={() => onView(row)}><FaEye /> View</button>
                      <button type="button" className="sd-attachment-btn" title="History and attachments" onClick={() => onHistory(row)}><FaPaperclip /></button>
                    </div></td>
                  </tr>;
                })}
            </tbody>
          </table>
        </div>
        <footer className="sd-table-footer">
          <div className="sd-total">Showing <strong>{start}–{end}</strong> of <strong>{effectiveTotal}</strong> entries</div>
          <div className="sd-page-controls">
            <span>Show</span>
            <select value={pageSize} onChange={e => onPageSizeChange(Number(e.target.value))} aria-label="Entries per page">
              {[7, 10, 15, 25].map(n => <option key={n} value={n}>{n}</option>)}
            </select>
            <span>entries per page</span>
            <button className="sd-page-btn" disabled={page <= 1} onClick={() => onPageChange(page - 1)} aria-label="Previous page"><FaChevronLeft /></button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).filter(p => p === 1 || p === totalPages || Math.abs(p - page) <= 1).map((p, i, arr) => (
              <React.Fragment key={p}>
                {i > 0 && p - arr[i - 1] > 1 && <span>…</span>}
                <button className={`sd-page-btn ${p === page ? "active" : ""}`} onClick={() => onPageChange(p)}>{p}</button>
              </React.Fragment>
            ))}
            <button className="sd-page-btn" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} aria-label="Next page"><FaChevronRight /></button>
          </div>
        </footer>
      </section>
    </>
  );
}
